import { createFileRoute, redirect } from '@tanstack/react-router';
import { queryClient } from '@/app/providers/QueryProvider/client.ts';
import { fetchMediationsOptions } from '@/entities/mediation/api/fetchMediationsOptions.ts';
import { MediationStatus } from '@/entities/mediation/model/types.ts';

export const Route = createFileRoute('/_layout/cabinet/')({
  loader: async ({ preload }) => {
    if (preload) {
      return;
    }

    const response = await queryClient.fetchQuery(fetchMediationsOptions());
    const mediations = response.data.mediations;

    const hasPendingApplication = mediations.find(
      (mediation) => mediation.status === MediationStatus.Pending
    );
    const hasSignedApplication = mediations.find(
      (mediation) => mediation.status === MediationStatus.Signed
    );

    if (hasPendingApplication) {
      throw redirect({
        to: '/cabinet/applications',
        search: { shouldOpenApplication: false },
      });
    }

    if (hasSignedApplication) {
      throw redirect({ to: '/cabinet/schedules', replace: true });
    }

    throw redirect({ to: '/cabinet/profile', replace: true });
  },
});
